// ================================================================================
// wp-block-location-floating-banner.js
// 店舗フローティングボタンのスクリプトファイル
// ================================================================================

document.addEventListener('DOMContentLoaded', function() {

	const targets = document.querySelectorAll('.wp-block-location-floating-banner, .wp-pattern-location-floating-buttons');
	const footer = document.querySelector('.wp-pattern-footer');

	if (!targets.length || !footer) return;

	// 閉じる（bannerのみ）
	document.querySelectorAll('.wp-block-location-floating-banner').forEach(function(banner) {
		const closeBtn = banner.querySelector('.js-location-floating-banner-close');
		if (!closeBtn) return;

		closeBtn.addEventListener('click', function() {
			banner.classList.add('is-close');
		});
	});

	// フッターで表示制御
	const observer = new IntersectionObserver(function(entries) {
		const isFooterVisible = entries[0].isIntersecting;

		targets.forEach(function(el) {
			el.classList.toggle('is-hidden', isFooterVisible);
		});
	}, {
		root: null,
		threshold: 0
	});

	observer.observe(footer);

});
